/**
 * The site footer.
 *
 * A top-level namespace rather than a child of `nav`: the footer is one
 * component rendered by the marketing layout, not part of the in-app navigation
 * surfaces, and burying it under `nav` invited mixing the two when the landing
 * page and the app shell diverged.
 */
export const footer = {
  tagline: "Your Language Learning Platform",
  description:
    "Build confidence in English speaking with AI-powered practice sessions, vocabulary drills, and real-time feedback. Learn at your own pace.",
  sections: {
    learn: "Learn",
    support: "Support",
    community: "Community",
  },
  links: {
    browseTopics: "Browse Topics",
    browseTopicsDescription: "Explore practice topics",
    vocabulary: "Vocabulary",
    vocabularyDescription: "Build your word bank",
    studyGroups: "Study Groups",
    studyGroupsDescription: "Learn with others",
    leaderboard: "Leaderboard",
    leaderboardDescription: "Track your progress",
    features: "Features",
    faq: "FAQ",
    community: "Community",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
  },
  communityBlurb:
    "Join our community of language learners and get tips, motivation, and support.",
  allRightsReserved: "© {{year}} Lyder Talk. All rights reserved.",
  madeWith: "Made with",
  forLearners: "for learners",
} as const;
